import React, {useEffect} from "react";

import Modal from '@material-ui/core/Modal';

import FormHelperText from '@material-ui/core/FormHelperText';

import FormControl from '@material-ui/core/FormControl';
import Button from "@material-ui/core/Button";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import {CircularProgress, Grid} from "@material-ui/core";
import {useHistory, useParams} from "react-router-dom";
import {CoursePage} from "../../../../../routes/studentRoutes";
import {generateDynamicRoute} from "../../../../../utils/utils";
import {AdminUtilisateursModifierGroupePage} from "../../../../../routes/administratorRoutes";
import {adminUtilisateursFetchGroupe} from "../../../../../store/actions/admin/utilisateurs/groupeActions";
import {adminUtilisateursAjouterGroupe} from "../../../../../store/actions/admin/utilisateurs/ajouterGroupeActions";
import {
    adminUtilisateursFetchGroupeListeGroupes, adminUtilisateursFetchGroupeListeUtilisateurs,
    adminUtilisateursFetchListeGroupes
} from "../../../../../store/actions/admin/utilisateurs/listeGroupesActions";
import {adminUtilisateursFetchListeUtilisateurs} from "../../../../../store/actions/admin/utilisateurs/listeUtilisateursActions";
import {connect} from "react-redux";
import Chip from "@material-ui/core/Chip";


import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';



import DateFnsUtils from '@date-io/date-fns';

import {
    DateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {adminAssignementsGroupeCoursAjouterAssignementGroupeCours} from "../../../../../store/actions/admin/assignementsGroupeCours/ajouterAssignementGroupeCoursActions";
import Alert from "@material-ui/lab/Alert";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import TreeListeGroupesSingleAdd from "../../../../../components/TreeListeGroupesSingleAdd";
import Box from "@material-ui/core/Box";
import TreeListeGroupesMultiAdd from "../../../../../components/TreeListeGroupesMultiAdd";
import {adminCoursFetchListeCours} from "../../../../../store/actions/admin/cours/listeCoursActions";
import TreeListe from "../../../../../components/TreeListe";
import {
    adminCoursFetchCategorieListeCategories, adminCoursFetchCategorieListeCours,
    adminCoursFetchListeCategories
} from "../../../../../store/actions/admin/cours/listeCategoriesActions";
import {adminAssignementsGroupeCategorieAjouterAssignementGroupeCategorie} from "../../../../../store/actions/admin/assignementsGroupeCategorie/ajouterAssignementGroupeCategorieActions";
import {adminUtilisateursModifierGroupeAjouterSousGroupe} from "../../../../../store/actions/admin/utilisateurs/modifierGroupeActions";
import {
    adminUtilisateursAjouterUtilisateurAuGroupe,
    adminUtilisateursAjouterUtilisateurAuGroupeReset
} from "../../../../../store/actions/admin/utilisateurs/ajouterUtilisateurAuGroupeActions";

const initialState = {
    groupe: {value : null, error : null},
    groupesExpanded : false,
};

function AjouterGroupeModal(props) {



    const handleGroupesExpanded = (event,isExpanded) => {
        setState(prevState => {
            return {
                ...prevState,
                groupesExpanded : isExpanded
            }
        });
    };

    useEffect(() => {
        if(props.open)
            props.fetchListeGroupes();
        else {
            props.ajouterUtilisateurAuGroupeReset()
        }
    },[props.open]);

    const [state, setState] = React.useState(initialState);

    const formOnSubmitHandler = (event) => {

        event.preventDefault();

        let error = false;

        const groupe = state.groupe.value;

        if(!groupe) {
            error = true;
            setState(prevState => {
                return {
                    ...prevState,
                    groupe: {
                        value: null,
                        error : "Le groupe est obligatoire"
                    }
                }
            })
        }


        if(!error) {
            props.ajouterUtilisateurAuGroupe(props.utilisateur.id,groupe.id);
        }

    };

    const handleGroupeSelect = (groupe) => {
        setState(prevState => {
            return {
                ...prevState,
                groupe: {value : groupe, error : null }
            };
        });
    };

    const handleGroupeUnSelect = () => {
        setState(prevState => {
            return {
                ...prevState,
                groupe: {value : null, error : null }
            };
        });
    };


    const isGroupeSelected = (groupeToCheck) => {
        return state.groupe.value && state.groupe.value.id === groupeToCheck.id;
    };


    return(
        <Modal
            open={props.open}
            onClose={props.handleClose}
            style={{overflowY:"auto"}}
        >
            <div style={{maxWidth:"700px", width:"100%"}} className={"bg-white text-center border rounded mx-auto my-5"}>

                <h2>Ajouter un groupe</h2>

                {props.ajouterUtilisateurAuGroupeState.error &&
                <Alert className={"mt-2 mb-3"} variant="filled" severity="error">{props.ajouterUtilisateurAuGroupeState.error}</Alert>
                }
                {props.ajouterUtilisateurAuGroupeState.success&&
                <Alert className={"mt-2 mb-3"} variant="filled" severity="success">L'utilisateur ajouté avec succees</Alert>
                }


                <form className={"text-left p-4"} onSubmit={formOnSubmitHandler}>


                        <ExpansionPanel expanded={state.groupesExpanded} onChange={handleGroupesExpanded}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <FormControl error={state.groupe.error ? true : false}>
                                <h6>Groupe : {!state.groupessExpanded && state.groupe.value ? <Chip label={state.groupe.value.nom} onDelete={handleGroupeUnSelect} /> : null}</h6>
                                    {state.groupe.error && <FormHelperText>{state.groupe.error}</FormHelperText>}
                                </FormControl>

                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails >
                                {props.listeGroupes.loading ?
                                    <CircularProgress size={50} thickness={4} />
                                    :
                                    <Grid container spacing={3}>

                                        <Grid item xs={12} md={8} >
                                            <span>Selectionner un groupe</span>

                                            <TreeListe fetchGroupeListeGroupes={props.fetchGroupeListeGroupes} onlyGroupes={true} selectable={"Groupe"} liste={props.listeGroupes.listeGroupes} handleSelect={handleGroupeSelect} handleUnSelect={handleGroupeUnSelect} isGroupeSelected={isGroupeSelected}/>

                                        </Grid>
                                        <Grid item xs={12} md={4} >
                                            <span>Groupe Selectionné</span>
                                            <Box>
                                                {state.groupe.value &&
                                                <Chip
                                                    label={state.groupe.value.nom }
                                                    onDelete={handleGroupeUnSelect}
                                                />}
                                            </Box>
                                        </Grid>

                                    </Grid>
                                }
                            </ExpansionPanelDetails>
                        </ExpansionPanel>



                                    <div>
                                        <Button disabled={props.ajouterUtilisateurAuGroupeState.loading} type={"submit"} className={"my-2"}
                                                color={"primary"} variant={"contained"} endIcon={<PersonAddIcon/>}>Ajouter</Button>
                                        {props.ajouterUtilisateurAuGroupeState.loading && <CircularProgress size={24} /*className={spinnerClasses.join(" ")}*/ />}
                                    </div>

                </form>


            </div>
        </Modal>
    );




}

const mapStateToProps = (state) => {
    return {
        ajouterUtilisateurAuGroupeState : state.admin.utilisateurs.ajouterUtilisateurAuGroupe,
        listeGroupes : state.admin.utilisateurs.listeGroupes
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        ajouterUtilisateurAuGroupe : (utilisateurId,groupeId) => dispatch(adminUtilisateursAjouterUtilisateurAuGroupe(utilisateurId,groupeId)),
        ajouterUtilisateurAuGroupeReset : () => dispatch(adminUtilisateursAjouterUtilisateurAuGroupeReset()),

        fetchListeGroupes : () => dispatch(adminUtilisateursFetchListeGroupes()),
        fetchGroupeListeGroupes : (groupeId) => dispatch(adminUtilisateursFetchGroupeListeGroupes(groupeId))

    }
};

export default connect(mapStateToProps,mapDispatchToProps)(AjouterGroupeModal);